import { Action } from '@ngrx/store';
import * as authentication from '../../actions/data/authentication';
import { ICredentials, IAuthenticationResult, ILoginResult, IUpdatePassword } from '../../../authentication/types';

//beacon
import { createMetaReducer } from 'redux-beacon';
import {
  GoogleAnalytics,
  PageView,
  Event,
  Exception
} from 'redux-beacon/targets/google-analytics';

// import { logger } from 'redux-beacon/extensions/logger'; // if need to log to console

// Map the event to an ngrx/store action
const eventsMap = {
    '[Data Authentication] Server Login Failure': (action: Action): Event => ({
        hitType: 'event',
        eventCategory: 'Authentication',
        eventAction: 'Login Fail',
        eventLabel:  action.payload['message']
    }),
    '[Data Authentication] Server Login Success': (action: Action): Event => ({
        hitType: 'event',
        eventCategory: 'Authentication',
        eventAction: 'Login Success'
    }),
    '[Data Authentication] Server Reset Password Success' : (action: Action): Event => ({
        hitType: 'event',
        eventCategory: 'Authentication',
        eventAction: 'Reset password Success'
    }),
    '[Data Authentication] Server Reset Password Failure' : (action: Action): Event => ({
        hitType: 'event',
        eventCategory: 'Authentication',
        eventAction: 'Reset password Fail',
        eventLabel:  action.payload['message']
    }),
    '[Data Authentication] Server Update Password Success': (action: Action): Event => ({
        hitType: 'event',
        eventCategory: 'Authentication',
        eventAction: 'Update Password Success'
    }),
    '[Data Authentication] Server Update Password Failure': (action: Action): Event => ({
        hitType: 'event',
        eventCategory: 'Authentication',
        eventAction: 'Update Password Fail',
        eventLabel:  action.payload['message']
    })
};

// Create the meta Reducer
export const analyticsAuthenticationMetaReducer = createMetaReducer(eventsMap, GoogleAnalytics);



// WEBPACK FOOTER //
// ./src/app/stateManagement/reducers/metaReducer/authentication.metaReducer.ts